<script>
    import {replace} from "svelte-spa-router";
    import {docs,logueo} from '../store.js';
    import {beforeUpdate,onMount} from 'svelte';
	let clientes = [];
	let mes = "";
    let meses = [
		"Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto",
		"Diciembre","Septiembre","Octubre","Noviembre","Diciembre"
    ];
	let locales = [];
	let local = "";
    let parar = false;
    let pantalla = "";
    let contador = 15;
    let cant = 0;
    let timer;
    let filtroMes = "",filtroTipo = "",filtroServicio = "";
    function sortear(){
		window.scrollTo(0,window.innerHeight);
        if (!parar){
        timer = setInterval(()=>{
            if (contador < 0){
                parar = true;
            } else {
                let c = clientes[Math.round(Math.random()*clientes.length-1)];
                let dni = c.documento.slice(-3);
                pantalla = (filtroTipo == "Instagram"?
                `${c.instagram}` : `${c.nombre} - ${dni}`
                );
                contador -= 1;
            }
        },50);
        }
    }
    onMount(()=>{
		if (locales){
            locales = $docs.filter((el)=> el._id.includes("local:"));
            clientes = $docs.filter((el)=>el._id.includes("cliente:"));
            cant = clientes.length - 1;
        }
        if (!$logueo){
			replace('/');
		}
	})
    beforeUpdate(()=>{
        if (parar){
            contador = 15;
            parar = false;
            clearInterval(timer);
            timer = undefined;
        }
        if (clientes){
            clientes = $docs.filter((el)=>el._id.includes("cliente:"));
            if (filtroMes != ""){
                clientes = clientes.filter((el)=>{
                    let mesCumple = new Date(el.cumple).getMonth();
                    return (mesCumple == filtroMes);
                })
            }
            if (filtroTipo == "Instagram"){
                clientes = clientes.filter((el)=> el.instagram != " " && el.instagram != "" && el.instagram != undefined);
            }
            if (local != ""){
				clientes = clientes.filter((el)=>el.documentos[0].local == local);
			}
            if (filtroServicio != ""){
                clientes = clientes.filter((el)=>el.documentos[0].cuerpo[1].nombre == filtroServicio);
            }
            cant = clientes.length - 1;
        }
    })
</script>

<div class="w-full p-4 h-full flex flex-col items-center justify-start">
	<a href="#/clientes" class="w-full m-2 p-2 bg-red-500 text-white cursor-pointer flex items-center justify-center rounded shadow">
			<i class="ri-arrow-left-line" />
			Volver
	</a>
	<select bind:value={filtroMes} class="m-2 p-2 w-full bg-white rounded shadow">
		<option value="">Cumpleaños</option>
		{#each meses as mes,i}
			<option value={i}>{mes}</option>
		{/each}
	</select>
	<select bind:value={local} class="m-2 p-2 w-full bg-white rounded shadow">
		<option value="">Local</option>
		{#each locales as local,i}
			<option value={local.nombre}>{local.nombre}</option>
		{/each}
	</select>
	<select bind:value={filtroServicio} class="m-2 p-2 w-full bg-white rounded shadow">
		<option value="">Servicio</option>
		<option value="Tatuaje">Tatuaje</option>
		<option value="Perforación">Perforación</option>
	</select>
	<select bind:value={filtroTipo} class="m-2 p-2 w-full bg-white rounded shadow">
		<option value="">Nombre</option>
		<option value="Instagram">Instagram</option>
	</select>
	<button on:click={sortear} class="m-2 p-2 w-full rounded shadow bg-red-500 text-white hover:bg-red-300 cursor-pointer flex items-center">
		<i class="ri-recycle-line" /> Sortear!
	</button>
</div>
<div class="w-full h-screen bg-red-500 flex items-center justify-center">
	<div class="w-80 h-80 m-8 shadow-xl rounded-full overflow-hidden">
		<div class="bg-white w-full h-full flex items-center justify-center">
		   <h1 class="text-2xl font-bold">{pantalla}</h1>
		</div>
   </div>
</div>
